<div [formGroup]="formGroup">
<mat-card>
    <mat-card-header>The Basics</mat-card-header>
    <mat-card-content>
      <mat-form-field>
        <mat-label>Project ID</mat-label>
        <input matInput disabled [value]="project.id" />
      </mat-form-field>
    
      <mat-form-field>
        <mat-label>Project Title</mat-label>
        <input matInput formControlName="project_title" />
      </mat-form-field>
    
      <mat-form-field>
        <mat-label>Project Description</mat-label>
        <textarea matInput placeholder="You may describe your project here..." formControlName="project_description"></textarea>
      </mat-form-field>
    
      <mat-form-field>
        <mat-label>Layout Direction</mat-label>
        <mat-select formControlName="layout_direction">
          <mat-option value="ltr">Left to Right</mat-option>
          <mat-option value="rtl">Right to Left</mat-option>
        </mat-select>
        <mat-hint>Which way is your languge read? “Left to Right” is like Greek; “Right to Left” is like Hebrew.</mat-hint>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Gloss Suggestion Mode</mat-label>
        <mat-select formControlName="gloss_suggestion_mode">
          <mat-option value="byBinyanOrVoice">Show suggestions based on lexical item and voice/binyan</mat-option>
          <mat-option value="byLexicalItem">Show suggestions based on lexical item only</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox formControlName="allow_joins">Allow anyone to join (you can still remove them at any time)</mat-checkbox>
      
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-header>Numerals</mat-card-header>
    <mat-card-content>
      <mat-form-field>
    <mat-label>Enter the numbers for your language like 0,1,2,3,4,5,6,7,8,9 (no spaces; separated by commas)</mat-label>
    <input matInput formControlName="numerals" type="text" placeholder="0,1,2,3,4,5,6,7,8,9"  [appProjectTextStyle]="project" />
    @if( numerals?.invalid && (numerals?.dirty || numerals?.touched) ) {
      <mat-error>
        @if(numerals?.errors?.['required']) { 
          <span>Numerals are required.</span>
        }
        @if(numerals?.errors?.['tenDigits']) { 
          <span>Please enter exactly 10 digits.</span>
        }
      </mat-error>
    }
  </mat-form-field>
  @if( !numerals?.invalid ) {
  <div class="examples">
    <p>Examples:</p>
    <p>123 → {{demoChangeNumerals("123")}}</p>
    <p>405 → {{demoChangeNumerals("405")}}</p>
    <p>978 → {{demoChangeNumerals("978")}}</p>
    <p>629 → {{demoChangeNumerals("629")}}</p>
  </div>
  }

    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>Settings to help your language display correctly on this website</mat-card-header>
    <mat-card-content>

      <mat-form-field>
        <mat-label>Font Families</mat-label>
        <input matInput formControlName="font_families" />
        <mat-hint>Separate multiple values with commas.</mat-hint>
      </mat-form-field>
    
      <mat-form-field>
        <mat-label>Font Size</mat-label>
        <input matInput formControlName="font_size" type="number" />
      </mat-form-field>
    

    </mat-card-content>
  </mat-card>
</div>